import Checkbox from '@repo/ui/checkbox'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'

import { checkTripSchedule } from '../../api/trips-schedule/check-trip-schedule'
import { uncheckTripSchedule } from '../../api/trips-schedule/uncheck-trip-schedule'

type Props = {
  code: string
  initialChecked: boolean
  onChange?: (checked: boolean) => void
}
const TripScheduleCheckbox: React.FC<Props> = ({ initialChecked, code, onChange }) => {
  const [checked, setChecked] = useState(initialChecked)

  const { mutate: check, isPending: isCheckPending } = useMutation({
    mutationFn: checkTripSchedule,
    onSuccess: () => {
      setChecked(true)
    },
    onError: () => {
      setChecked(false)
    }
  })

  const { mutate: uncheck, isPending: isUncheckPending } = useMutation({
    mutationFn: uncheckTripSchedule,
    onSuccess: () => {
      setChecked(false)
    },
    onError: () => {
      setChecked(true)
    }
  })

  return (
    <div>
      <Checkbox
        loading={isCheckPending || isUncheckPending}
        checked={checked}
        onChange={() => {
          if (checked) uncheck(code)
          else check(code)
          onChange?.(!checked)
        }}
      />
    </div>
  )
}

export default TripScheduleCheckbox
